import { render } from "./NavFullScreen.vue?vue&type=template&id=0eb7670a&scoped=true"
import script from "./NavFullScreen.vue?vue&type=script&lang=js"
export * from "./NavFullScreen.vue?vue&type=script&lang=js"

import "./NavFullScreen.vue?vue&type=style&index=0&id=0eb7670a&scoped=true&lang=css"

import exportComponent from "/Users/nikita/Documents/works/novofamil/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0eb7670a"]])

export default __exports__